import { render, staticRenderFns } from "./YoneticiDuzenle.vue?vue&type=template&id=1b33437b&scoped=true&"
import script from "./YoneticiDuzenle.vue?vue&type=script&lang=js&"
export * from "./YoneticiDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./YoneticiDuzenle.vue?vue&type=style&index=0&id=1b33437b&lang=scss&scoped=true&"
import style1 from "./YoneticiDuzenle.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b33437b",
  null
  
)

export default component.exports